import React from 'react';
import { Grid } from '@mui/material';
import getBaseEditor, { CommandPanels } from '../../BaseEditor';

const editorRenderer = (getControl) => (
  <Grid container spacing={2}>
    <Grid item sm={4}>
      {getControl('datefrom')}
    </Grid>
    <Grid item sm={4}>
      {getControl('dateto')}
    </Grid>
    <Grid item sm={4}>
      {getControl('value')}
    </Grid>
  </Grid>
);

export default getBaseEditor(editorRenderer, '/api/catalog/salaries/', CommandPanels.catCommandPanel);
